import React from 'react';
import './DeleteInputFormsForQuestionsImg.scss';
import { imgQuestionDelete, closeDeleteInputFormsForQuestionsImg } from '../../../adminSlice';

const DeleteInputFormsForQuestionsImg  = (props) => {
   
    const { dispatch } = props;
  
 // CLICK OK
    const onSend = () => {
        

            const item = {
                quizId: props.adminState.selectedQuize,
                questionId: props.adminState.selectedId,
                imgName: props.adminState.selectedImgName
            }
            console.log(item);
        dispatch(imgQuestionDelete(item));
        dispatch(closeDeleteInputFormsForQuestionsImg()); 
    }


    // CLOSE FORM
    const onClose = () => {
       
        dispatch(closeDeleteInputFormsForQuestionsImg());

    }


   

     
        return(
            <div className="DeleteInputFormsForQuestionsImg">
                <p className='p-text'>id: {props.adminState.selectedId}</p>
                <p>Вы действительно хотите удалить изображение для вопроса?</p>
                
                <button onClick={onSend}>Да</button>
                <button onClick={onClose}>Отмена</button>
            </div>
        )
    
       
     

        
    
}
export default DeleteInputFormsForQuestionsImg;